import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import Acquisition from "./Images/Cost 1002.png";
import Interactive from "./Images/Intractive 1002.png";
import Opening from "./Images/Opening Rate 1001.png";
import WhatsApp from "./Images/Users1001.png";

const stats = [
  {
    icon: Interactive,
    value: 800,
    unit: 'msec',
    label: "Interactive time",
    color: "#eafbf1",
  },
  {
    icon: Acquisition,
    value: 30,
    unit: '₹',
    label: "Acquisition cost",
    color: "#f5f1ee",
  },
  {
    icon: Opening,
    value: 30,
    unit: '%',
    label: "Opening rate",
    color: "#e2e9f0",
  },
  {
    icon: WhatsApp,
    value: 3,
    unit: 'Bn+',
    label: " WhatsApp users",
    color: "#e3e9ff",
  },
];

const animateValue = (obj, start, end, duration) => {
  let startTimestamp = null;

  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerText = Math.floor(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};


const ShinyPaper = styled(Paper)(({ theme, bgcolor }) => ({
  position: "relative",
  padding: theme.spacing(2),
  height: "100%",
  width: "100%",
  borderRadius: theme.spacing(1),
  backgroundColor: bgcolor,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  fontSize: "3rem",
  overflow: "hidden",
  boxShadow: "2px 2px 10px #DADADA",
  transition: "0.3s linear all",
  "&:hover": {
    boxShadow: "4px 4px 20px #DADADA",
    cursor: 'pointer',
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-75%",
    height: "100%",
    width: "50%",
    background: "linear-gradient(120deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.2) 100%)",
    transform: "skewX(-20deg)",
  },
  "&:hover::before": {
    animation: "shine 0.75s forwards",
    cursor: 'pointer',
  },
  "@keyframes shine": {
    to: {
      left: "125%",
    },
  },
}));

const StatCard = ({ icon, value, label, color, unit }) => {

  const counterRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (counterRef.current) {
      observer.observe(counterRef.current);
    }
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (visible && counterRef.current) {
      animateValue(counterRef.current, 0, value, 3000);
    }
  }, [visible, value]);

  return (
    <ShinyPaper bgcolor={color}>
      <Box sx={{
        // border: "1px solid red",
        opacity: 0.9, fontSize: "3.5rem", mr: 2, color: "black",
      }}>
        <img
          src={icon}
          width={64}
          height={64}
        />
      </Box>

      <Box sx={{ position: "relative", flexGrow: 1 }}>
        <Typography
          variant="subtitle1"
          sx={{
            // border: "1px solid red",
            position: "absolute",
            top: 0,
            right: 10,
            // fontStyle: "italic",
            textTransform: "capitalize",
            color: "#333",
            opacity: 0.7,
            fontSize: 16,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            // border: "1px solid red",
            position: "absolute",
            bottom: 0,
            right: 10,
            fontWeight: "bold",
            fontSize: 24,
            // color: "rgba(12, 12, 12, 0.8)",
            color: "#333"
          }}
        >
          <span
            ref={counterRef}
            id="value"
          >
          </span>
          <span>
            &nbsp;{unit}
          </span>
        </Typography>

      </Box>
    </ShinyPaper>
  );
};


const StatsColumn = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: '100%',
        height: '100%',
        gap: 2,
      }}
    >
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </Box>
  );
};

export default StatsColumn;


